import { getCrossingProducts, getMixedProducts, getAnnualityProducts, getRechargeProducts } from '@/api/products'

const getDefaultState = () => {
  const initialState = {
    balanceProducts: [],
    annualityProducts: [],
    mixedProducts: [],
    rechargeProduct: {},
    selectedProductId: null
  }

  // Change name to crossingProducts
  if (localStorage.getItem('crossingProducts')) {
    initialState.balanceProducts = JSON.parse(localStorage.getItem('crossingProducts'))
  }
  if (localStorage.getItem('balanceProducts')) {
    initialState.balanceProducts = JSON.parse(localStorage.getItem('balanceProducts'))
  }
  if (localStorage.getItem('mixedProducts')) {
    initialState.mixedProducts = JSON.parse(localStorage.getItem('mixedProducts'))
  }
  if (localStorage.getItem('annualityProducts')) {
    initialState.annualityProducts = JSON.parse(localStorage.getItem('annualityProducts'))
  }
  if (localStorage.getItem('rechargeProduct')) {
    initialState.rechargeProduct = JSON.parse(localStorage.getItem('rechargeProduct'))
  }

  return initialState
}

const state = getDefaultState()

const mutations = {
  SET_BALANCE_PRODUCTS: (state, data) => {
    state.balanceProducts = data
    localStorage.setItem('balanceProducts', JSON.stringify(data))
  },
  SET_MIXED_PRODUCTS: (state, data) => {
    state.mixedProducts = data
    localStorage.setItem('mixedProducts', JSON.stringify(data))
  },
  SET_ANNUALITY_PRODUCTS: (state, data) => {
    state.annualityProducts = data
    localStorage.setItem('annualityProducts', JSON.stringify(data))
  },
  SET_RECHARGE_PRODUCT: (state, data) => {
    state.rechargeProduct = data[0]
    localStorage.setItem('rechargeProduct', JSON.stringify(data[0]))
  },
  SELECT_PRODUCT: (state, productId) => {
    state.selectedProductId = productId
  }
}

const actions = {
  getCrossingProductsList ({ commit }) {
    return new Promise((resolve, reject) => {
      getCrossingProducts().then(response => {
        const data = response.data
        commit('SET_BALANCE_PRODUCTS', data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMixedProductsList ({ commit }) {
    return new Promise((resolve, reject) => {
      getMixedProducts().then(response => {
        const data = response.data
        commit('SET_MIXED_PRODUCTS', data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAnnualityProductsList ({ commit }) {
    return new Promise((resolve, reject) => {
      getAnnualityProducts().then(response => {
        const data = response.data
        commit('SET_ANNUALITY_PRODUCTS', data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  async getRechargeProductsList ({ commit }) {
    try {
      const { data } = await getRechargeProducts()
      commit('SET_RECHARGE_PRODUCT', data)
    } catch (error) {
    }
  },
  selectProduct ({ commit }, productId) {
    commit('SELECT_PRODUCT', productId)
  }
}

const getters = {
  annualityProducts: state => state.annualityProducts,
  mixedProducts: state => state.mixedProducts,
  // REMOVE
  crossingProducts: state => state.balanceProducts,
  balanceProducts: state => state.balanceProducts,
  rechargeProduct: state => state.rechargeProduct,
  selectedProduct: state => {
    let selectedProduct = state.balanceProducts.find(product => (
      product.id === state.selectedProductId
    ))

    if (!selectedProduct) {
      selectedProduct = state.annualityProducts.find(product => (
        product.id === state.selectedProductId
      ))
    }
    if (!selectedProduct) {
      selectedProduct = state.mixedProducts.find(product => (
        product.id === state.selectedProductId
      ))
    }

    return selectedProduct
  },
  selectedProductFormattedPrice: (state, getters) => {
    const selectedProduct = getters.selectedProduct

    if (selectedProduct && selectedProduct.price) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'MXN', currencyDisplay: 'symbol' }).format(selectedProduct.price)
    }

    return null
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
